import { Nav } from "../components/Nav";
import { Footer } from "../components/Footer";
import { Marquee } from "../components/Marquee";
import { SmoothScroll } from "../components/SmoothScroll";
import { Hero } from "../sections/Hero";
import { Bento } from "../sections/Bento";
import { Process } from "../sections/Process";
import { Workshop } from "../sections/Workshop";

export default function Home() {
  return (
    <SmoothScroll>
      <Nav />
      <main>
        <Hero />
        <Marquee />
        <Bento />
        <Process />
        <Workshop />
      </main>
      <Footer />
    </SmoothScroll>
  );
}
